/**
 * Trigger a browser download from blob response data.
 * Desktop keeps the anchor download. Phone and iPad save through the device.
 */
import { isHandheldDevice, saveFileOnHandheld } from './handheldFile.js';

export function filenameFromContentDisposition(disposition, fallback) {
  if (!disposition) return fallback;
  const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition);
  if (star) {
    try {
      return decodeURIComponent(star[1].trim().replace(/^["']|["']$/g, ''));
    } catch {
      return star[1].trim();
    }
  }
  const quoted = /filename="([^"]+)"/i.exec(disposition);
  if (quoted) return quoted[1];
  const plain = /filename=([^;]+)/i.exec(disposition);
  if (plain) return plain[1].trim().replace(/^["']|["']$/g, '');
  return fallback;
}

export function downloadBlob(blobData, filename, mimeType) {
  const blob =
    blobData instanceof Blob
      ? blobData
      : new Blob([blobData], { type: mimeType || 'application/octet-stream' });

  if (isHandheldDevice()) {
    const typed = blob.type
      ? blob
      : new Blob([blob], { type: mimeType || 'application/octet-stream' });
    return saveFileOnHandheld(typed, filename);
  }

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return Promise.resolve();
}

export default downloadBlob;
